<template>
  <div class="col-span-6">
    <label for="field.label" class="block 2xl:text-sm sm:text-xl font-medium leading-5 text-gray-700">
      {{field.label}}
    </label>
    <div class="mt-4 mb-4 space-y-4">
      <button
        type="button"
        :key="field.label"
        v-on:click="goButton(field.uri)"
        class="border-gray-300 text-gray-700 hover:bg-gray-50 bg-white border rounded-md shadow-sm py-2 px-4 inline-flex justify-center 2xl:text-sm sm:text-xl font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-light-blue-500 disabled:opacity-50"
        :disabled="disabled"
      >
      {{field.value}}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'button-field',
  data() {
    return {
      disabled: true,
      dependentdata: {},
    }
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    formdata: {
      type: Object,
      required: true
    }
  },
  created() {
    this.checkDepends()
  },
  watch: {
    formdata: {
      deep: true,
      handler: async function(newVal)  {
        if (this.field.depends !== '' && this.field.depends !== undefined) {
          if ( typeof this.dependentdata[this.field.depends] === 'object'){
            if (this.field.depends in newVal) {
              if (JSON.stringify(this.dependentdata[this.field.depends]) !== JSON.stringify(newVal[this.field.depends])) {
                this.dependentdata[this.field.depends] = JSON.parse(JSON.stringify(newVal[this.field.depends]))
                this.disabled = false
                this.$store.commit('setState', this.dependentdata)
              }
            }
          }else {
            if (this.field.depends in newVal) {
              if (this.dependentdata[this.field.depends] !== newVal[this.field.depends]) {
                this.dependentdata[this.field.depends] = JSON.parse(JSON.stringify(newVal[this.field.depends]))
                this.disabled = false
                this.$store.commit('setState', this.dependentdata)
              }
            }
          }
        }
      }
    },
  },
  methods: {
    checkDepends() {
      if (this.field.depends === undefined || this.field.depends === "") {
        this.disabled = false
      }
    },
    goButton(uri) {

      this.$router.push(uri)
      this.$router.go()
    },
  }
}
</script>
